
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="分页下拉配置" fileName="paging-configuration.md" />
        <demo-block>
        <div><p><code>pageSizeOption</code> 属性设置分页下拉配置</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;ve-pagination :total=&quot;600&quot; :page-size-option=&quot;[5,10,15]&quot; :page-size=&quot;5&quot; /&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('ve-pagination',{attrs:{"total":600,"page-size-option":[5,10,15],"page-size":5}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  